
export const ADD_FAVOURITE = "ADD_FAVOURITE"
export const ADD_FAVOURITE_FAIL = "ADD_FAVOURITE_FAIL"
export const ADD_FAVOURITE_SUCCESS = "ADD_FAVOURITE_SUCCESS"



export const GET_FAVOURITE = "GET_FAVOURITE"
export const GET_FAVOURITE_FAIL = "GET_FAVOURITE_FAIL"
export const GET_FAVOURITE_SUCCESS = "GET_FAVOURITE_SUCCESS"


